import styled from 'styled-components'

export const TextInput = styled.div``
export const Button = styled.div`
	cursor: pointer;
`

export const View = styled.div<{hover?: string}>`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;

	${({hover}) => hover && `
		&:hover {
			color: ${hover};
		}
	`}
`

// export const Text = styled.div`
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     flex-direction: row;
// `;
export const Text = styled.div<{ size?: number }>`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
	font-family: 'Roboto';
	
	${({ size }) =>
		size &&
		`
        @media only screen and (max-width: 600px) {
           font-size: ${size - 4}px;
        }
        @media only screen and (min-width: 600px) {
           font-size: ${size - 3}px;
        }
        @media only screen and (min-width: 768px) {
           font-size: ${size - 2}px;
        }
        @media only screen and (min-width: 992px) {
           font-size: ${size - 1}px;
        }
        @media only screen and (min-width: 1200px) {
           font-size: ${size}px;
        }
   `}
`
export const ScrollView = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	flex: 1;
	overflow-y: auto;
`

export const TouchableOpacity = styled.div`
	display: flex;
`

export const Image = styled.div`
	display: flex;
	background-size: cover;
`

export const Row = styled.div`
	display: flex;
	flex-direction: row;
`

export const Column = styled.div<{
	alignItems?: string
	justifyContent?: string
}>`
	display: flex;
	flex-direction: column;
	align-items: ${props => props.alignItems};
	justify-content: ${props => props.justifyContent};
`
